import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Badge } from "react-bootstrap";
import Select from "react-select";

const CategorySelector = ({ categories = [], onChange }) => {
  const [search, setSearch] = useState("");

  const [level1, setLevel1] = useState("");
  const [level2, setLevel2] = useState("");
  const [level3, setLevel3] = useState("");
  const [level4, setLevel4] = useState("");

  const rootCategories = categories.filter((cat) =>
    cat.name.toLowerCase().includes(search.toLowerCase()),
  );

  const selectedLevel1Obj =
    rootCategories.find((c) => c._id === level1) ||
    categories.find((c) => c._id === level1);

  const level2Categories = selectedLevel1Obj?.children || [];

  const selectedLevel2Obj = level2Categories.find((c) => c._id === level2);

  const level3Categories = selectedLevel2Obj?.children || [];

  const selectedLevel3Obj = level3Categories.find((c) => c._id === level3);

  const level4Categories = selectedLevel3Obj?.children || [];

  const selectedLevel4Obj = level4Categories.find((c) => c._id === level4);

  const selectedCategoryId = level4 || level3 || level2 || level1 || "";

  useEffect(() => {
    onChange(selectedCategoryId);
  }, [selectedCategoryId, onChange]);

  return (
    <div className="w-full bg-white rounded-2xl shadow-md border border-gray-100 p-6">
      <h2 className="text-lg font-semibold text-gray-800 mb-4">
        Select Category
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* LEVEL 1 */}
        <div>
          <label className="text-sm font-medium text-gray-600 mb-1 block">
            Level 1 Category
          </label>
          <Select
            className="text-sm"
            placeholder="Choose Level 1"
            options={rootCategories.map((cat) => ({
              value: cat._id,
              label: cat.name,
            }))}
            value={
              level1
                ? {
                    value: level1,
                    label: selectedLevel1Obj?.name,
                  }
                : null
            }
            onChange={(selected) => {
              setLevel1(selected?.value || "");
              setLevel2("");
              setLevel3("");
              setLevel4("");
            }}
          />
        </div>

        {/* LEVEL 2 */}
        <div>
          <label className="text-sm font-medium text-gray-600 mb-1 block">
            Level 2 Category
          </label>
          <Select
            className="text-sm"
            isDisabled={!level1}
            placeholder="Choose Level 2"
            options={level2Categories.map((cat) => ({
              value: cat._id,
              label: cat.name,
            }))}
            value={
              level2
                ? {
                    value: level2,
                    label: selectedLevel2Obj?.name,
                  }
                : null
            }
            onChange={(selected) => {
              setLevel2(selected?.value || "");
              setLevel3("");
              setLevel4("");
            }}
          />
        </div>

        {/* LEVEL 3 */}
        <div>
          <label className="text-sm font-medium text-gray-600 mb-1 block">
            Level 3 Category
          </label>
          <Select
            className="text-sm"
            isDisabled={!level2}
            placeholder="Choose Level 3"
            options={level3Categories.map((cat) => ({
              value: cat._id,
              label: cat.name,
            }))}
            value={
              level3
                ? {
                    value: level3,
                    label: selectedLevel3Obj?.name,
                  }
                : null
            }
            onChange={(selected) => {
              setLevel3(selected?.value || "");
              setLevel4("");
            }}
          />
        </div>
      </div>

      {/* SELECTED PATH */}
      {(selectedLevel1Obj || selectedLevel2Obj || selectedLevel3Obj) && (
        <div className="mt-6">
          <p className="text-sm font-medium text-gray-600 mb-2">
            Selected Path
          </p>

          <div className="flex flex-wrap gap-2">
            {selectedLevel1Obj && (
              <span className="px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-xs font-medium">
                {selectedLevel1Obj.name}
              </span>
            )}

            {selectedLevel2Obj && (
              <span className="px-3 py-1 rounded-full bg-green-100 text-green-700 text-xs font-medium">
                {selectedLevel2Obj.name}
              </span>
            )}

            {selectedLevel3Obj && (
              <span className="px-3 py-1 rounded-full bg-yellow-100 text-yellow-700 text-xs font-medium">
                {selectedLevel3Obj.name}
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CategorySelector;
